<template>
  <div
    :class="['email-component', 'gift-card-component', { selected }]"
    :style="computedStyles"
    @click="handleClick"
  >
    <div class="gift-card-wrapper" :style="wrapperStyles">
      <!-- Gift Card Image (if enabled) -->
      <div
        v-if="componentData.showImage && isImageSideLayout"
        class="gift-card-image-container"
        :style="imageContainerStyles"
      >
        <div class="placeholder-image" :style="imagePlaceholderStyles">
          <i class="tim-icons icon-credit-card"></i>
          <span>Gift Card Design</span>
        </div>
      </div>

      <!-- Gift Card Content -->
      <div class="gift-card-content" :style="contentStyles">
        <!-- Image Top Layout -->
        <div
          v-if="componentData.showImage && !isImageSideLayout"
          class="gift-card-image-container"
          :style="imageContainerStyles"
        >
          <div class="placeholder-image" :style="imagePlaceholderStyles">
            <i class="tim-icons icon-credit-card"></i>
            <span>Gift Card Design</span>
          </div>
        </div>

        <!-- Gift Card Code (Always Displayed) -->
        <div class="gift-card-code-section" :style="codeSectionStyles">
          <div class="code-label" :style="codeLabelStyles">
            {{ getLabel('giftCardCode') }}
          </div>
          <div class="code-value" :style="codeValueStyles">
            XXXX-XXXX-XXXX
          </div>
        </div>

        <!-- Personal Message (if enabled) -->
        <div
          v-if="componentData.showPersonalMessage"
          class="personal-message-section"
          :style="messageSectionStyles"
        >
<!--          <div class="message-label" :style="messageLabelStyles">-->
<!--            {{ getLabel('personalMessage') }}-->
<!--          </div>-->
          <div class="message-content" :style="messageContentStyles">
            This is a sample personal message that will be included with the gift card.
          </div>
        </div>

        <!-- Gift Card Details Grid -->
        <div class="gift-card-details" :style="detailsContainerStyles">
          <!-- Total Value (if enabled) -->
          <div
            v-if="componentData.showTotal"
            class="detail-item"
            :style="detailItemStyles"
          >
            <div class="detail-content">
              <div class="detail-label" :style="labelStyles">
                {{ getLabel('totalValue') }}
              </div>
              <div class="detail-value" :style="valueStyles">
                $100.00
              </div>
            </div>
          </div>

          <!-- Remaining Value (if enabled) -->
          <div
            v-if="componentData.showRemaining"
            class="detail-item"
            :style="detailItemStyles"
          >
            <div class="detail-content">
              <div class="detail-label" :style="labelStyles">
                {{ getLabel('remainingValue') }}
              </div>
              <div class="detail-value" :style="valueStyles">
                $100.00
              </div>
            </div>
          </div>

          <!-- Activation Date (if enabled) -->
          <div
            v-if="componentData.showActivationDate"
            class="detail-item"
            :style="detailItemStyles"
          >
            <div class="detail-content">
              <div class="detail-label" :style="labelStyles">
                {{ getLabel('activationDate') }}
              </div>
              <div class="detail-value" :style="valueStyles">
                Jan 15, 2025
              </div>
            </div>
          </div>

          <!-- Expiration Date (if enabled) -->
          <div
            v-if="componentData.showExpirationDate"
            class="detail-item"
            :style="detailItemStyles"
          >
            <div class="detail-content">
              <div class="detail-label" :style="labelStyles">
                {{ getLabel('expirationDate') }}
              </div>
              <div class="detail-value" :style="valueStyles">
                Jan 15, 2026
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GiftCardComponent',
  props: ['componentData', 'selected'],
  data() {
    return {
      labels: {
        english: {
          giftCardCode: 'Gift Card Code',
          personalMessage: 'Personal Message',
          totalValue: 'Total Value',
          remainingValue: 'Remaining Value',
          activationDate: 'Activation Date',
          expirationDate: 'Expiration Date'
        },
        spanish: {
          giftCardCode: 'Código de Tarjeta de Regalo',
          personalMessage: 'Mensaje Personal',
          totalValue: 'Valor Total',
          remainingValue: 'Valor Restante',
          activationDate: 'Fecha de Activación',
          expirationDate: 'Fecha de Expiración'
        },
        french: {
          giftCardCode: 'Code de Carte Cadeau',
          personalMessage: 'Message Personnel',
          totalValue: 'Valeur Totale',
          remainingValue: 'Valeur Restante',
          activationDate: "Date d'Activation",
          expirationDate: "Date d'Expiration"
        },
        swedish: {
          giftCardCode: 'Presentkortskod',
          personalMessage: 'Personligt Meddelande',
          totalValue: 'Totalt Värde',
          remainingValue: 'Återstående Värde',
          activationDate: 'Aktiveringsdatum',
          expirationDate: 'Utgångsdatum'
        },
        danish: {
          giftCardCode: 'Gavekortkode',
          personalMessage: 'Personlig besked',
          totalValue: 'Samlet værdi',
          remainingValue: 'Resterende værdi',
          activationDate: 'Aktiveringsdato',
          expirationDate: 'Udløbsdato'
        },
        greek: {
          giftCardCode: 'Κωδικός Δωροκάρτας',
          personalMessage: 'Προσωπικό Μήνυμα',
          totalValue: 'Συνολική Αξία',
          remainingValue: 'Υπόλοιπο',
          activationDate: 'Ημερομηνία Ενεργοποίησης',
          expirationDate: 'Ημερομηνία Λήξης'
        }
      }
    }
  },
  computed: {
    currentLanguage() {
      return this.componentData.language || 'english'
    },

    currentLayout() {
      return this.componentData.layout || 'image-top'
    },

    isImageSideLayout() {
      return this.currentLayout === 'image-left' || this.currentLayout === 'image-right'
    },

    computedStyles() {
      const styles = this.componentData.styles || {}
      const backgroundColor = styles.backgroundColor === 'inherit' || !styles.backgroundColor ?
        'transparent' : styles.backgroundColor

      return {
        backgroundColor: backgroundColor,
        padding: `${styles.paddingTop || '20'}px ${styles.paddingLeft || '20'}px ${styles.paddingBottom || '20'}px ${styles.paddingRight || '20'}px`,
        marginTop: `${styles.marginTop || '16'}px`,
        marginBottom: `${styles.marginBottom || '16'}px`,
        borderRadius: `${styles.borderRadius || '8'}px`,
        border: styles.showBorder ? `1px solid ${styles.borderColor || '#e5e7eb'}` : 'none',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    wrapperStyles() {
      if (!this.isImageSideLayout) {
        return { display: 'block' }
      }

      return {
        display: 'flex',
        flexDirection: this.currentLayout === 'image-left' ? 'row' : 'row-reverse',
        gap: '20px',
        alignItems: 'flex-start'
      }
    },

    imageContainerStyles() {
      const styles = this.componentData.styles || {}

      if (this.isImageSideLayout) {
        return {
          flexShrink: '0',
          width: `${styles.imageWidth || '40'}%`,
          minWidth: '150px'
        }
      }

      return {
        marginBottom: '16px',
        textAlign: this.componentData.imageAlignment || 'center'
      }
    },

    imagePlaceholderStyles() {
      const styles = this.componentData.styles || {}

      const baseStyles = {
        backgroundColor: '#f3f4f6',
        borderRadius: `${styles.imageBorderRadius || '8'}px`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        color: '#9ca3af',
        fontSize: '14px'
      }

      if (this.isImageSideLayout) {
        return {
          ...baseStyles,
          width: '100%',
          height: '250px'
        }
      }

      return {
        ...baseStyles,
        width: `${styles.imageWidth || '100'}%`,
        maxWidth: '100%',
        height: '200px',
        margin: this.componentData.imageAlignment === 'center' ? '0 auto' : '0'
      }
    },

    contentStyles() {
      if (this.isImageSideLayout) {
        return {
          flex: '1',
          minWidth: '0'
        }
      }
      return {}
    },

    codeSectionStyles() {
      const styles = this.componentData.styles || {}
      return {
        textAlign: 'center',
        padding: `${styles.codePadding || '16'}px`,
        backgroundColor: styles.codeBackgroundColor || 'rgba(225, 78, 202, 0.1)',
        borderRadius: `${styles.codeBorderRadius || '8'}px`,
        marginBottom: '16px',
        border: styles.showCodeBorder ? `2px solid ${styles.codeBorderColor || '#e14eca'}` : 'none'
      }
    },

    codeLabelStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.codeLabelFontSize || '12'}px`,
        fontWeight: styles.codeLabelFontWeight || '600',
        color: styles.codeLabelColor || '#6b7280',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '8px',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    codeValueStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.codeFontSize || '24'}px`,
        fontWeight: styles.codeFontWeight || '700',
        color: styles.codeColor || '#e14eca',
        fontFamily: styles.codeFont || 'Monaco, Courier, monospace',
        letterSpacing: '2px'
      }
    },

    messageSectionStyles() {
      const styles = this.componentData.styles || {}
      return {
        padding: `${styles.messagePadding || '12'}px`,
        backgroundColor: styles.messageBackgroundColor || 'rgba(249, 250, 251, 0.5)',
        borderRadius: `${styles.messageBorderRadius || '6'}px`,
        marginBottom: '16px',
        // borderLeft: `3px solid ${styles.messageBorderColor || '#e14eca'}`
      }
    },

    messageLabelStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.messageLabelFontSize || '11'}px`,
        fontWeight: styles.messageLabelFontWeight || '600',
        color: styles.messageLabelColor || '#6b7280',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '6px',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    messageContentStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.messageFontSize || '14'}px`,
        fontWeight: styles.messageFontWeight || '400',
        color: styles.messageColor || '#374151',
        lineHeight: '1.6',
        fontFamily: styles.fontFamily || 'Arial, sans-serif',
        fontStyle: 'italic'
      }
    },

    detailsContainerStyles() {
      const styles = this.componentData.styles || {}
      return {
        display: 'grid',
        gridTemplateColumns: styles.detailsLayout === 'vertical' ? '1fr' : 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '12px',
        marginTop: '8px'
      }
    },

    detailItemStyles() {
      const styles = this.componentData.styles || {}
      return {
        padding: `${styles.detailPadding || '12'}px`,
        backgroundColor: styles.detailBackgroundColor || 'transparent',
        borderRadius: `${styles.detailBorderRadius || '6'}px`,
        border: styles.showDetailBorder ? `1px solid ${styles.detailBorderColor || '#e5e7eb'}` : 'none'
      }
    },

    labelStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.labelFontSize || '11'}px`,
        fontWeight: styles.labelFontWeight || '600',
        color: styles.labelColor || '#9ca3af',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '4px',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    valueStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.valueFontSize || '16'}px`,
        fontWeight: styles.valueFontWeight || '600',
        color: styles.valueColor || '#111827',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },

    getLabel(key) {
      const languageLabels = this.labels[this.currentLanguage] || this.labels.english
      return languageLabels[key] || key
    }
  }
}
</script>

<style scoped>
.gift-card-component {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  width: 100%;
  box-sizing: border-box;
}

.gift-card-component:hover,
.gift-card-component.selected {
  border-color: #e14eca !important;
  box-shadow: 0 0 0 4px rgba(225, 78, 202, 0.1);
}

.gift-card-wrapper {
  width: 100%;
}

.placeholder-image i {
  font-size: 48px;
}

.gift-card-content {
  width: 100%;
}

.gift-card-code-section {
  width: 100%;
}

.code-value {
  word-break: break-all;
}

.personal-message-section {
  width: 100%;
}

.message-content {
  word-wrap: break-word;
  white-space: pre-wrap;
}

.gift-card-details {
  width: 100%;
}

.detail-item {
  min-width: 0;
}

.detail-content {
  min-width: 0;
  width: 100%;
}

.detail-label,
.detail-value {
  word-wrap: break-word;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .gift-card-wrapper {
    flex-direction: column !important;
  }

  .gift-card-image-container {
    width: 100% !important;
  }

  .gift-card-details {
    grid-template-columns: 1fr !important;
  }

  .code-value {
    font-size: 18px !important;
  }
}
</style>
